module.exports = __webpack_public_path__ + "static/logo-792e3f2bf1b82b356e4dc8edf36a42e6.png";